import { RecordMessage } from '@/types/record';
import { useThrottle } from 'ahooks';
import { useCallback, useMemo, useRef, useState } from 'react';

export function useBarrageList() {
  const barrageList = useRef<RecordMessage[]>([]);
  const [moreLoading, setMoreLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [updateTag, setUpdateTag] = useState(1);
  const [nowUpdateTag, setNowUpdateTag] = useState(1);
  const [hasNewBarrage, setHasNewBarrage] = useState<boolean>(false);
  const tempMap: React.MutableRefObject<Record<string, RecordMessage>> = useRef({});
  // const [listKey, setListKey] = useState(new Date().getTime());
  const updateTagT = useThrottle(updateTag, { wait: 180 });

  const pushRecord = useCallback((record: RecordMessage) => {
    const uid = record.yxuid || record.uid;
    if (tempMap.current[uid]?.clearTimer) window.clearTimeout(tempMap.current[uid]?.clearTimer);
    if (record.sentenceType === 2) {
      tempMap.current[uid] = {
        ...record,
        id: record.yxuid,
        clearTimer: window.setTimeout(() => {
          if (tempMap.current[uid]) {
            delete tempMap.current[uid];
            setUpdateTag((n) => n + 1);
          }
        }, 5000), // 5s后没有后续状态就清除
      };
      setUpdateTag((n) => n + 1);
    } else {
      delete tempMap.current[uid];
      barrageList.current.push(record);
      setUpdateTag((n) => n + 1);
    }
  }, []);

  const clearRecord = useCallback((all: boolean) => {
    if (all) {
      setHasMore(true);
      barrageList.current = [];
      // setListKey(new Date().getTime());
    }
    tempMap.current = {};
    setNowUpdateTag((n) => n + 1);
  }, []);

  const loadHistoryRecord = useCallback((list: any) => {
    barrageList.current = [...list, ...barrageList.current];
    setNowUpdateTag((n) => n + 1);
  }, []);

  const resultList = useMemo((): RecordMessage[] => {
    return [...barrageList.current, ...Object.values(tempMap.current)];
  }, [updateTagT, nowUpdateTag]);

  return {
    barrageList: resultList,
    moreLoading,
    setMoreLoading,
    hasMore,
    setHasMore,
    pushRecord,
    loadHistoryRecord,
    clearRecord,
    hasNewBarrage,
    setHasNewBarrage,
  };
}
